function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react-refresh/only-export-components -- exports non-component values alongside the provider */
import React, { createContext, useMemo } from 'react';
import { useTheme } from '@deephaven/components';
import CellDropdownField from "./CellDropdownField.js";
import { createDefaultIrisGridTheme } from "./IrisGridTheme.js";
import { STRING_LIST_RESTRICTION_TYPE } from "./IrisGridModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
var renderStringListRestriction = props => {
  var restrictions = props.restrictions;
  var _ref = restrictions[0],
    allowedValues = _ref.allowedValues;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/_jsx(CellDropdownField, _objectSpread(_objectSpread({}, props), {}, {
    options: allowedValues
  }));
};
renderStringListRestriction.preservesExistingValue = true;

/**
 * The default registry containing DHC's built-in cell input renderers.
 * Pass this (or a superset of it) as the `registry` prop of
 * {@link IrisGridContextProvider} to include the DHC defaults.
 */
export var DEFAULT_REGISTRY = new Map([[STRING_LIST_RESTRICTION_TYPE, renderStringListRestriction]]);

/**
 * The context value for the IrisGridContextProvider.
 * This must be a full object and not a partial so that we
 * can createDefaultIrisGridTheme once, and not per grid.
 */

/**
 * The context for the IrisGrid, providing the theme, density, and cell input renderer registry.
 */
export var IrisGridContext = /*#__PURE__*/createContext({
  theme: null,
  density: 'regular',
  cellInputRendererRegistry: DEFAULT_REGISTRY
});
IrisGridContext.displayName = 'IrisGridContext';
export function IrisGridContextProvider(_ref2) {
  var children = _ref2.children,
    _ref2$density = _ref2.density,
    density = _ref2$density === void 0 ? 'regular' : _ref2$density,
    _ref2$registry = _ref2.registry,
    registry = _ref2$registry === void 0 ? DEFAULT_REGISTRY : _ref2$registry;
  var _useTheme = useTheme(),
    activeThemes = _useTheme.activeThemes;
  var gridTheme = useMemo(() => createDefaultIrisGridTheme(),
  // When the theme changes, we need to update the grid theme which reads CSS variables to JS
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [activeThemes]);
  var contextValue = useMemo(() => ({
    theme: gridTheme,
    density,
    cellInputRendererRegistry: registry
  }), [gridTheme, density, registry]);
  return /*#__PURE__*/_jsx(IrisGridContext.Provider, {
    value: contextValue,
    children: children
  });
}
//# sourceMappingURL=IrisGridContextProvider.js.map